import { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';
import type { BundleDraft } from './bundle-config';
import { useBundlesStore } from './use-bundles-store';

/**
 * Seeds the owner's catalogue editor from the server render once, and pulls a
 * save into the page. Returns false until the store holds the catalogue.
 */
export function useOwnerCatalogue(bundles: BundleDraft[], currency: string, username: string) {
  const initialize = useBundlesStore((s) => s.initialize);
  const editingId = useBundlesStore((s) => s.editingId);
  const savedAt = useBundlesStore((s) => s.savedAt);
  const [seeded, setSeeded] = useState(false);
  const router = useRouter();

  useEffect(() => {
    initialize(currency, username, bundles);
    setSeeded(true);
    // Seeded once from the server render. Later saves change the page's data
    // and every bundle's id, and re-seeding from that would swap the ids out
    // from under an open editor mid-keystroke.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // A save has already revalidated the server cache; this pulls it into the
  // client's. Held back while an editor is open, so a Remove's refresh cannot
  // land under a card being typed in.
  useEffect(() => {
    if (savedAt && !editingId) router.refresh();
  }, [savedAt, editingId, router]);

  return seeded;
}
